import React, { useState, useEffect, useCallback } from "react";
import { Polygon, Marker } from "@react-google-maps/api";
import axios from "axios";
import { PageHeader } from '@ant-design/pro-layout';
import MapComponent from "../../components/MapComponent";
import ListFormComponent from "../../components/ListFormComponent";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import {useAxios} from "../../hooks/hooks";

function ProjectMapPage(props) {
  const axios = useAxios();
  const options = {
    title: {
      text: "My chart",
    },
    series: [
      {
        data: [1, 2, 3],
      },
    ],
  };
  const polygonOptions = {
    fillColor: "#00FF00",
    fillOpacity: 1,
    strokeColor: "#FF0000",
    strokeOpacity: 1,
    strokeWeight: 2,
  };

  const [forbidden, setForbidden] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [projects, setProjects] = useState([]);
  const [currentProject, setCurrentProject] = useState(null);
  const [chartOptions, setChartOptions] = useState(null);

  const getCustomerProjects = async () => {
    var rows = [];
    var url = "customer-projects-polygons";
    const response = await axios.current.get(url);
    rows = response.data.rows;
    if (rows.error) {
      setError(JSON.stringify(rows.error));
      return null;
    }
    rows.forEach((r, i) => {
      rows[i].polygon_project = JSON.parse(r.polygon_project);
      rows[i].latitude_project = Number(r.latitude_project);
      rows[i].longitude_project = Number(r.longitude_project);
    });
    return rows;
  };

  const getCustomerEvents = useCallback(async () => {
    var rows = [];
    var url = `risk-overview?filter[id_company]=${props.userProfile.id_company}`;
    const response = await axios.current.get(url);
    rows = response.data.rows;
    if (rows.error) {
      setError(JSON.stringify(rows.error));
      return null;
    }
    return rows;
  }, [props.userProfile.id_company]);

  const getRemovedRisks = useCallback(async () => {
    var rows = [];
    var url = `removed-risk-overview?filter[id_company]=${props.userProfile.id_company}`;
    const response = await axios.current.get(url);
    rows = response.data.rows;
    if (rows.error) {
      setError(JSON.stringify(rows.error));
      return null;
    }
    return rows;
  }, [props.userProfile.id_company]);

  useEffect(() => {
    const func = async () => {
      var p = await getCustomerProjects();
      setProjects(p);
      var events = await getCustomerEvents();
      var removedrisks = await getRemovedRisks();
      var risks = ["Low", "Medium", "High", "Unknown"];
      var materials = [
        "Asbestos",
        "Lead-Based Paint System",
        "SMF",
        "PCB",
        "ODS",
        "Other",
        "Lead Containing Dust",
        "Inaccessible Areas",
      ];
      var options = {
        chart: {
          type: "column",
          height: 600,
        },
        title: {
          text: "Current HBM Risk - Overview",
        },
        subtitle: {
          text: "(Base year 2021)",
        },
        xAxis: {
          categories: [
            "Asbestos",
            "Lead-Based Paint System",
            "SMF",
            "PCB",
            "ODS",
            "Asbestos Containing Dust",
            "Lead Containing Dust",
            "Inaccessible Areas",
          ],
          title: {
            text: "Type of HBM",
          },
        },
        legend: {
          labelFormatter: function () {
            if (this.name.indexOf("-") === -1) {
              return this.name;
            }
            return "";
          },
        },
        yAxis: {
          allowDecimals: false,
          min: 0,
          title: {
            text: "Quantity of HBM",
          },
          tickInterval: 1,
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: "bold",
              color: "black",
            },
            formatter: function () {
              return this.total === 0 ? "" : this.stack;
            },
          },
        },
        tooltip: {
          formatter: function () {
            return (
              "<b>" +
              this.x +
              "</b><br/>" +
              this.series.name +
              ": " +
              this.y +
              "<br/>" +
              "Total: " +
              this.point.stackTotal
            );
          },
        },
        plotOptions: {
          column: {
            stacking: "normal",
          },
        },
        series: [
          {
            name: "Low",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            color: "#00FF00",
            stack: "2021",
          },
          {
            name: "Medium",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            color: "#FFCC00",
            stack: "2021",
          },
          {
            name: "High",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            color: "#FF0000",
            stack: "2021",
          },
          {
            name: "Unknown",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            color: "#FF6600",
            stack: "2021",
          },
          {
            name: "Low - Current",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            color: "#00FF00",
            showInLegend: false,
            stack: "Current",
          },
          {
            name: "Medium - Current",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            color: "#FFCC00",
            showInLegend: false,
            stack: "Current",
          },
          {
            name: "High - Current",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            color: "#FF0000",
            showInLegend: false,
            stack: "Current",
          },
          {
            name: "Unknown - Current",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            color: "#FF6600",
            showInLegend: false,
            stack: "Current",
          },
          {
            name: "Low - Removed Risk",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            color: "#00FF00",
            showInLegend: false,
            stack: "Removed",
          },
          {
            name: "Medium - Removed Risk",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            color: "#FFCC00",
            showInLegend: false,
            stack: "Removed",
          },
          {
            name: "High - Removed Risk",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            color: "#FF0000",
            showInLegend: false,
            stack: "Removed",
          },
          {
            name: "Unknown - Removed Risk",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            color: "#FF6600",
            showInLegend: false,
            stack: "Removed",
          },
        ],
      };

      events.forEach((e) => {
        if (e.risk_score !== "Negligible") {
          const id_material = materials.indexOf(e.type_of_hazmat);
          const id_series = risks.indexOf(e.risk_score);
          // Include all events past base year in current column
          if (e.inspection_year >= 2021) {
            options.series[1 * risks.length + id_series].data[id_material] +=
              e.total;
            // Include only events occuring in base year in base column
            if (e.inspection_year === 2021) {
              options.series[0 * risks.length + id_series].data[id_material] =
                e.total;
            }
          }
        }
      });

      removedrisks.forEach((r) => {
        if (r.risk_score !== "Negligible") {
          const id_material = materials.indexOf(r.type_of_hazmat);
          const id_series = risks.indexOf(r.risk_score);
          // Add to removed column
          options.series[2 * risks.length + id_series].data[id_material] =
            parseInt(r.total);
          // Subtract from current column
          options.series[1 * risks.length + id_series].data[id_material] -=
            parseInt(r.total);
        }
      });

      // var risk_length = options.xAxis.categories.length;
      // for (var b = 0; b < risk_length; b++) {
      //   for (var a = 0; a < 5; a++) {
      //     var total = 20 - Math.round(Math.random() * 20);
      //     var removed = total - Math.round(Math.random() * total);
      //     var diff = total - removed;
      //     console.log(total, removed, diff);
      //     options.series[a].data[b] = total;
      //     options.series[a + 5].data[b] = diff;
      //     options.series[a + 10].data[b] = removed;
      //   }
      // }
      setChartOptions(options);
    };
    func();
  }, [getCustomerEvents, getRemovedRisks]);

  return (
    <>
      <div style={{ width: "100%", height: "600px" }}>
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      </div>
      <PageHeader title="Projects Map" onBack={false} />
      <MapComponent>
        {projects.map((p) => (
          <Polygon
            key={p.id_view_project}
            paths={p.polygon_project}
            options={polygonOptions}
            onClick={(x) => {
              setCurrentProject(p.id_view_project);
            }}
          />
        ))}
        {projects.map((p) => (
          <Marker
            key={p.id_view_project}
            position={{
              lat: p.latitude_project,
              lng: p.longitude_project,
            }}
            label={p.id_view_project.toString()}
          />
        ))}
      </MapComponent>
      {currentProject != null && (
        <ListFormComponent
          home="/dashboard/"
          endpoint={props.endpoints["customer-events"].list}
          endpoints={props.endpoints}
          history={props.history}
          create={false}
          filter={{
            id_project: currentProject,
          }}
        />
      )}
    </>
  );
}

export default ProjectMapPage;
